"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/modules/auth/stores/useAuthStore";
import { useActiveStore } from "@/modules/store/stores/useActiveStore";
import { sessionKey } from "@/shell/services/session-bootstrap";
import { useCartStore } from "../stores/useCartStore";

/**
 * Carrega o carrinho da loja ativa quando cliente e loja já resolveram, e
 * recarrega quando um dos dois muda. Normalmente o bootstrap da sessão já
 * trouxe o carrinho e marcou a chave; este efeito é o caminho de recuperação.
 * Monte em qualquer tela que exiba o carrinho — chamar em várias é inofensivo.
 */
export function useCartSync(): void {
    const authStatus = useAuthStore((s) => s.status);
    const storeReady = useActiveStore((s) => s.ready);
    const storeId = useActiveStore((s) => s.storeId);

    useEffect(() => {
        if (authStatus === "loading" || !storeReady || storeId <= 0) return;

        const key = sessionKey(useAuthStore.getState().user?.cpfCnpj, storeId);
        if (useCartStore.getState().loadedKey === key) return;

        void useCartStore.getState().refresh();
    }, [authStatus, storeReady, storeId]);
}
